import { Component, effect, input, signal } from '@angular/core';
import { RelativeTimePipe } from '@context/frontend/common';
import { getUaDevice } from '@context/frontend/native/platform';
import { Content } from '@context/shared/types/common';
import { ContentLog } from '@context/shared/types/log';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIcon } from '@taiga-ui/core';
import { TuiBadge } from '@taiga-ui/kit';
import { DocumentReference, getDoc } from 'firebase/firestore';
import { LogThumbnailComponent } from '../log-thumbnail/log-thumbnail.component';

@Component({
	imports: [
		RelativeTimePipe,
		TranslocoModule,
		TuiIcon,
		LogThumbnailComponent,
		TuiBadge,
	],
	selector: 'ctx-log-row',
	templateUrl: 'log-row.component.html',
	styleUrl: 'log-row.component.scss',
	host: {
		'[attr.device]': 'device',
	},
})
export class LogRowComponent {
	readonly device = getUaDevice();

	readonly log = input.required<ContentLog>();

	readonly logRef = input.required<DocumentReference<ContentLog>>();

	readonly parent = signal<Content | null>(null);

	constructor() {
		effect(async () => {
			const ref = this.logRef();
			if (!ref.parent) return;

			// parent == collection // parents parent == document
			const doc = await getDoc(
				ref.parent.parent as DocumentReference<Content>,
			);
			this.parent.set(doc.data() as Content);
		});
	}
}
